// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1b2fg","title":"AfterFrontImage_title__3eFs4"};